import React from "react";

const Modals: React.FC<any> = ({
  children,
  visible,
  closeModalHandler,
  className,
  Title,
  scroller,
  selectedYears,
}) => {
  return (
    <>
      {visible && (
        <>
          <div
            id="account-modal"
            aria-hidden="true"
            className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden"
          >
            <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-lg lg:max-w-3xl px-4 h-auto">
              <div
                className={`relative bg-white rounded-2xl shadow-2xl p-4 md:p-6 ${scroller}`}
              >
                <div
                  className={`flex justify-end items-center mb-4 ${className}`}
                >
                  <button
                    type="button"
                    className="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-full p-2 focus:outline-none"
                    onClick={closeModalHandler}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>

                <div className="flex flex-col items-center">
                  <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-[#F1AC20] text-center">
                    Patent No: {selectedYears.year}
                  </h2>
                  <div className="flex justify-center p-4 -mt-8 md:p-10">
                    <p className="text-gray-700 text-sm sm:text-base md:text-lg text-center">
                      {selectedYears.content} <span className="text-primary-color text-[14px]"><a href="http://patft.uspto.gov/netacgi/nph-Parser?Sect1=PTO2&Sect2=HITOFF&u=%2Fnetahtml%2FPTO%2Fsearch-adv.htm&r=4&p=1&f=G&l=50&d=PTXT&S1=seetharamakrish$.INNM.&OS=in/seetharamakrish$&RS=IN/seetharamakrish$" target="_blank"
                        rel="noopener noreferrer" >(Read)</a></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="fixed inset-0 z-40 bg-black opacity-50"></div>
        </>
      )}
    </>
  );
};

export default Modals;
